// Costanti fiscali (IVA esclusa)
export const ACCISA_PER_LITER_ALCOL_PURO = 10.3552; // €/L alcol puro

// Formatter EUR con millesimi (3 decimali) — usato per accise, contrassegni e costi industriali
export const formatCurrencyMillesimi = (value) => {
  return new Intl.NumberFormat('it-IT', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 3,
    maximumFractionDigits: 3
  }).format(value || 0);
};

// Estrae centilitri da una stringa formato tipo "50cl", "100cl", "5cl"
export const parseFormatCl = (formatStr) => {
  if (!formatStr) return 0;
  const m = String(formatStr).match(/(\d+(?:\.\d+)?)/);
  return m ? parseFloat(m[1]) : 0;
};

// Accisa per singola bottiglia (€, IVA esclusa)
// Es: 50cl @ 25% alcol -> 0.5 * 0.25 * 10.3552 = 1.2944 €
export const computeAccisaPerBottle = (formatStr, alcoholContent) => {
  const cl = parseFormatCl(formatStr);
  const alc = parseFloat(alcoholContent) || 0;
  if (cl <= 0 || alc <= 0) return 0;
  const liters = cl / 100;
  return liters * (alc / 100) * ACCISA_PER_LITER_ALCOL_PURO;
};

// Contrassegno di stato per bottiglia in base al formato
export const computeContrassegnoPerBottle = (formatStr) => {
  const cl = parseFormatCl(formatStr);
  if (cl <= 0) return 0;
  if (cl <= 10) return 0.005;
  if (cl <= 20) return 0.015;
  return 0.047;
};

// Riepilogo fiscale aggregato per array di items
// items: [{ format, quantity, alcohol_content | alcoholContent }]
export const computeFiscalSummary = (items, alcoholKey = 'alcohol_content') => {
  let totalAccisa = 0;
  let totalContrassegno = 0;
  let totalBottles = 0;
  (items || []).forEach((it) => {
    const qty = parseInt(it.quantity, 10) || 0;
    const alc = parseFloat(it[alcoholKey]) || 0;
    totalAccisa += computeAccisaPerBottle(it.format, alc) * qty;
    totalContrassegno += computeContrassegnoPerBottle(it.format) * qty;
    totalBottles += qty;
  });
  return {
    accisa: totalAccisa,
    contrassegno: totalContrassegno,
    totalFiscal: totalAccisa + totalContrassegno,
    totalBottles
  };
};
